module.exports = __webpack_public_path__ + "static/media/styled-components.cc968bcd.svg";